import { Flex, Heading } from "@chakra-ui/react";
import { useUser } from "../../hooks/use-user";
import NoPermissionRead from "../../ui/components/ui/NoPermission";
import { PatientRequestsStatistics } from "./PatientRequestsStatistics";
import { PatientRequestsTable } from "./PatientRequestsTable";

/**
 * Die Patientenanfragen haengen am selben Recht wie die Bewerber: Wer Bewerber sehen
 * darf, sieht auch Anfragen (PRD KAN-227, Umsetzungsentscheidung "Rechte").
 */
export const PatientRequestsParent = () => {
  const { user } = useUser();
  if (!user) return null;
  return (
    <>
      {user.permissionApplicants === "NONE" && !user.permissionOrganizationAdmin ? (
        <NoPermissionRead title="Patientenanfragen" />
      ) : (
        <PatientRequests />
      )}
    </>
  );
};

const PatientRequests = () => {
  return (
    <Flex direction="column" padding="1rem 1.5rem">
      <Flex width="100%" justifyContent="space-between" margin="0 0 1.5em">
        <Heading size="lg">Übersicht der Patientenanfragen</Heading>
      </Flex>
      <PatientRequestsStatistics />
      <PatientRequestsTable />
    </Flex>
  );
};
